/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Rectangle
 */
export interface Rectangle {
    /**
     * 
     */
    minX: number;
    /**
     * 
     */
    minY: number;
    /**
     * 
     */
    maxX: number;
    /**
     * 
     */
    maxY: number;
}

/**
 * Check if a given object implements the Rectangle interface.
 */
export function instanceOfRectangle(value: object): value is Rectangle {
    if (!('minX' in value) || value['minX'] === undefined) return false;
    if (!('minY' in value) || value['minY'] === undefined) return false;
    if (!('maxX' in value) || value['maxX'] === undefined) return false;
    if (!('maxY' in value) || value['maxY'] === undefined) return false;
    return true;
}

export function RectangleFromJSON(json: any): Rectangle {
    return RectangleFromJSONTyped(json, false);
}

export function RectangleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Rectangle {
    if (json == null) {
        return json;
    }
    return {
        
        'minX': json['minX'],
        'minY': json['minY'],
        'maxX': json['maxX'],
        'maxY': json['maxY'],
    };
}

export function RectangleToJSON(json: any): Rectangle {
    return RectangleToJSONTyped(json, false);
}

export function RectangleToJSONTyped(value?: Rectangle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minX': value['minX'],
        'minY': value['minY'],
        'maxX': value['maxX'],
        'maxY': value['maxY'],
    };
}

